import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import {GnSelectComponent} from './select.component';
import {NzSpinModule} from "ng-zorro-antd/spin";


@NgModule({
  declarations: [GnSelectComponent],
    imports: [
        CommonModule,
        FormsModule,
        NzSelectModule,
        NzSpinModule
    ],
  exports: [GnSelectComponent],
  entryComponents: []
})
export class GnSelectModule {
}
